

      <div class="modal-header justify-content-between add-entity">
        <h5 class="modal-title" style="float: left">Add Entity</h5>
       <ng-toggle
          [value]="isPerson ? toggleSettings.values.unchecked : toggleSettings.values.checked "
          [width]="isPerson ? 72 : 105"
          [height]="20"
          [labels]="toggleSettings.labels"
          [switchColor]="toggleSettings.switchColor"
          [color]="toggleSettings.color"
          [values]="toggleSettings.values"
          [fontColor]="toggleSettings.fontColor"
          (valueChange)="toggleChange($event)"
        />
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="closeModal()"
        >
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body padding-model form-editing">

        <div class="row">
          <div class="col-lg-12">
            <div class="card w-100">
              <div class="card">
                <form *ngIf="entityForm" [formGroup]="entityForm" (ngSubmit)="onSubmit()">
                  <div class="row">
                    <div class="width-120 zIndex">
                      <div class="mt-1">
                        <label for="roleId" class="form-title">
                          <span class="required">*</span>Role</label>
                        <ng-select class="custom role-select"
                                   id="roleId"
                                   [style.flex]="1"
                                   [items]="roleList"
                                   bindLabel="name"
                                   bindValue="id"
                                   placeholder="All"
                                   formControlName="roleId"
                                   [multiple]="true"
                                   (change)="handleRoleChange($event)"
                        >
                          <ng-template  ng-multi-label-tmp let-items="items" let-clear="clear">
                              <div *ngFor="let item of items" class="ng-value d-flex justify-content-center">
                                <span [title]="item.name"  tooltip="item.name" class="ng-value-label role-select-overflow">{{ item.name }}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                              </div>
        
                            <div *ngIf="items.length > 1" class="ng-value">
                              <span class="ng-value-label">{{ items.length - 1 }} more...</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      <app-form-error-component [control]="entityForm.controls['roleId']" />
                    </div>
        
                    <div *ngIf="!isPerson" class="width-185" style="z-index: 100001;">
                      <div class="mt-1">
                        <div class="d-flex justify-content-between">
                          <label for="name" class="form-title"><span
                            class="required">*</span>Organisation</label>
                          <div class="d-flex">
                            <label for="previousCheck" class="form-title me-2">Previous</label>
                            <input (change)="handlePreviewCheck($event)" formControlName="isPrevious" id="previousCheck"
                                   type="checkbox">
                          </div>
                        </div>
                      </div>
                      <ng-select
                        *ngIf="isNewEntity"
                        class="custom entityName"
                        id="name"
                        #nameNgSelect
                        [style.flex]="1"
                        [items]="entityNameList"
                        [addTag]="addNewTag"
                        
                        bindLabel="name"
                        bindValue="id"
                        placeholder="All"
                        formControlName="name"
                        [clearable]="true"
                        (search)="handleSearch($event)"
                        (change)="handleChange($event)"
                      >
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.name }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span [title]="item.name" tooltip="item.name">{{ item.name }}</span>
                      </ng-template> 

                    </ng-select>
                  
                      <input *ngIf="!isNewEntity" type="text" class="form-control" formControlName="name" id="name" />
                      <app-form-error-component [control]="entityForm.controls['name']" />
                    </div>
        
                    <div *ngIf="isPerson" class="width-355 d-flex align-items-baseline">
                      <div class="width-115">
                        <div class="mt-1">
                          <div class="d-flex justify-content-between">
                            <label for="firstName" class="form-title"><span class="required">*</span> First Name</label>
                          </div>
                        </div>
                        <div class="dropdown" style="z-index: 100001;">
                          <input [attr.type]="filteredOptions.length ? 'search' : 'text'" class="form-control" formControlName="firstName"
                                 id="firstName" autocomplete="off"
                                 (input)="onSearchInput($event)" 
                                 (focus)="showDropdown = true"
                                 (blur)="onBlur()" />
                          
                          <div class="dropdown-menu" [class.show]="showDropdown && filteredOptions.length > 0">
                            <a class="dropdown-item" *ngFor="let option of filteredOptions" (mousedown)="selectOption(option)">
                     
                              <span [title]="option.name" tooltip="option.name">{{ option.name }}</span>
                            </a>
                          </div>
                        </div>
                        
                        <app-form-error-component [control]="entityForm.controls['firstName']" />
                      </div>
                      <div class="mb-1 field-group width-115">
                        <label for="lastName" class="form-title"><span class="required">*</span> Last Name</label>
                        <input type="text" class="form-control" formControlName="lastName" id="lastName" />
                      </div>
        
                      <div class="mb-1 field-group width-120">
                        <label for="dob" class="form-title"> Date of Birth</label>
                        <div class="input-group birth_date">
                          <input type="text"
                                 class="form-control"
                                 placeholder="YYYY-MM-DD"
                                 name="d1"
                                 formControlName="birthDate"
                                 ngbDatepicker
                                 container="body"
                                 #d1="ngbDatepicker" />
                          <button class="btn btn-outline-secondary btn-calendar-icon" (click)="d1.toggle()" type="button"><img
                            alt="" src="./assets/images/icon/calendar-icon.svg" /></button>
                        </div>
                      </div>
                    </div>
        
                    <div *ngIf="isShowPreviousInput && !isPerson" class="width-165">
                      <div class="mt-1">
                        <label for="previousName" class="form-title">Previous Name</label>
                      </div>
                      <input
                        id="previousName"
                        type="text"
                        class="form-control ft-width"
                        placeholder=""
                        formControlName="previousName"
                      />
                      <app-form-error-component [control]="entityForm.controls['previousName']" />
                    </div>
                    <div class="width-165">
                      <div [class.mt-1]="!isPerson">
                        <label for="tradingAs" class="form-title">Trading As</label>
                      </div>
                      <input
                        id="tradingAs"
                        type="text"
                        class="form-control ft-width"
                        placeholder=""
                        formControlName="tradingAs"
                      />
                      <app-form-error-component [control]="entityForm.controls['tradingAs']" />
                    </div>
        
                    <div *ngIf="isPerson" class="width-165">
                      <div [class.mt-1]="!isPerson">
                        <label for="company" class="form-title">Company</label>
                      </div>
                      <ng-select
                        class="custom"
                        id="company"
                        [style.flex]="1"
                        [items]="organisationList"
                        
                        bindLabel="name"
                        bindValue="id"
                        placeholder="All"
                        formControlName="organisationEntityId"
                        [virtualScroll]="true"
                        [clearable]="true"
                      >
                        <ng-template ng-label-tmp let-item="item">
                          {{ item.name }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <span [title]="item.name" tooltip="item.name">{{ item.name }}</span>
                        </ng-template>
                      </ng-select>
                      <app-form-error-component [control]="entityForm.controls['organisationEntityId']" />
                    </div>
        
                    <ng-container>
                      <div class="card dabetors-creditor-card mt-2">
                        <div class="card-header">Contact Details</div>
                      </div>
        
                      <div class="d-flex overflow-auto max-height-145"
                           [style.width.%]="isCompareDialog ? 98 : 99">
                        <div class="me-3">
                          <div class="phone-container width-200" style="flex: 1">
                            <div>
                              <label for="mobile" class="form-title mb-0">Mobile Phone</label>
                              <div *ngFor="let phoneGroup of mobilePhonesControls.controls; let i = index"
                                   [formGroup]="phoneGroup"
                                   class="d-flex flex-column">
                                <div class="d-flex align-items-center">
                                  <input
                                    [id]="'mobile-' + i"
                                    type="text"
                                    class="form-control width-45 me-1 transparentPlaceholder"
                                    appOnlyNumber
                                    [allowedSign]="'+'"
                                    [keepSignAndZero]="true"
                                    maxlength="4"
                                    placeholder="+353"
                                    formControlName="countryCode"
                                    (change)="handleValidateMobilePhone(i)"
                                  />
                                  <input
                                    [id]="'mobile-' + i"
                                    type="text"
                                    class="form-control width-35 me-1 transparentPlaceholder"
                                    appOnlyNumber
                                    [keepSignAndZero]="true"
                                    maxlength="3"
                                    placeholder="87"
                                    formControlName="areaCode"
                                    (change)="handleValidateMobilePhone(i)"
                                  />
                                  <input
                                    [id]="'mobile-' + i"
                                    type="text"
                                    class="form-control width-80 transparentPlaceholder"
                                    [appOnlyNumber]="false"
                                    [keepSignAndZero]="true"
                                    placeholder="123-4567"
                                    formControlName="mobileNumber"
                                    (change)="handleValidateMobilePhone(i)"
                                  />
                                  <i
                                    class="bi bi-plus-circle ms-1 add-icon"
                                    *ngIf="i === mobilePhonesControls.length - 1"
                                    (click)="addNewInput('mobilePhones')"
                                  ></i>
                                  <i
                                    class="bi bi-dash-circle ms-1 remove-icon"
                                    *ngIf="mobilePhonesControls.length > 1"
                                    (click)="removeInput('mobilePhones', i)"
                                  ></i>
                                </div>
                                <div
                                  *ngIf="phoneGroup && phoneGroup.invalid && phoneGroup.hasError('invalidPhoneNumber') || phoneGroup.invalid"
                                  class="error-msg">
                                  <label for="" class="error">
                                    <img alt="" src="assets/images/icon/error.png" class="error-icon">
                                    Invalid phone number.
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
        
                          <div class="phone-container width-200" style="flex: 1">
                            <div>
                              <label for="home" class="form-title mb-0">Home Phone</label>
                              <div *ngFor="let homeGroup of homePhonesControls.controls; let i = index"
                                   [formGroup]="homeGroup"
                                   class="d-flex flex-column">
                                <div #homePhoneDiv class="d-flex align-items-center">
                                  <input
                                    [id]="'home-' + i"
                                    type="text"
                                    class="form-control width-45 me-1 transparentPlaceholder"
                                    appOnlyNumber
                                    [allowedSign]="'+'"
                                    [keepSignAndZero]="true"
                                    maxlength="4"
                                    placeholder="+353"
                                    formControlName="countryCode"
                                    (change)="handleValidateHomePhone(i)"
                                  />
                                  <input
                                    [id]="'home-' + i"
                                    type="text"
                                    class="form-control width-35 me-1 transparentPlaceholder"
                                    appOnlyNumber
                                    [keepSignAndZero]="true"
                                    maxlength="3"
                                    placeholder="1"
                                    formControlName="areaCode"
                                    (change)="handleValidateHomePhone(i)"
                                  />
                                  <input
                                    [id]="'home-' + i"
                                    type="text"
                                    class="form-control width-80 transparentPlaceholder"
                                    appOnlyNumber
                                    [keepSignAndZero]="true"
                                    placeholder="234-5678"
                                    formControlName="mobileNumber"
                                    (change)="handleValidateHomePhone(i)"
                                  />
                                  <i
                                    class="bi bi-plus-circle ms-1 add-icon"
                                    *ngIf="i === homePhonesControls.length - 1"
                                    (click)="addNewInput('homePhones')"
                                  ></i>
                                  <i
                                    class="bi bi-dash-circle ms-1 remove-icon"
                                    *ngIf="homePhonesControls.length > 1"
                                    (click)="removeInput('homePhones', i)"
                                  ></i>
                                </div>
                                <div
                                  *ngIf="homeGroup && homeGroup.invalid && homeGroup.hasError('invalidPhoneNumber') || homeGroup.invalid"
                                  class="error-msg">
                                  <label for="" class="error">
                                    <img alt="" src="assets/images/icon/error.png" class="error-icon">
                                    Invalid phone number.
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="phone-container width-200" style="flex: 1">
                            <div>
                              <label for="office" class="form-title mb-0">Office Phone</label>
                              <div *ngFor="let officeGroup of officePhonesControls.controls; let i = index"
                                   [formGroup]="officeGroup"
                                   class="d-flex flex-column">
                                <div class="d-flex align-items-center">
                                  <input
                                    [id]="'office-' + i"
                                    type="text"
                                    class="form-control width-45 me-1 transparentPlaceholder"
                                    appOnlyNumber
                                    [allowedSign]="'+'"
                                    [keepSignAndZero]="true"
                                    maxlength="4"
                                    placeholder="+353"
                                    formControlName="countryCode"
                                    (change)="handleValidateOfficePhone(i)"
                                  />
                                  <input
                                    [id]="'office-' + i"
                                    type="text"
                                    class="form-control width-35 me-1 transparentPlaceholder"
                                    appOnlyNumber
                                    [keepSignAndZero]="true"
                                    maxlength="3"
                                    placeholder="1"
                                    formControlName="areaCode"
                                    (change)="handleValidateOfficePhone(i)"
                                  />
                                  <input
                                    [id]="'office-' + i"
                                    type="text"
                                    class="form-control width-80 transparentPlaceholder"
                                    appOnlyNumber
                                    [keepSignAndZero]="true"
                                    placeholder="234-5678"
                                    formControlName="mobileNumber"
                                    (change)="handleValidateOfficePhone(i)"
                                  />
                                  <i
                                    class="bi bi-plus-circle ms-1 add-icon"
                                    *ngIf="i === officePhonesControls.length - 1"
                                    (click)="addNewInput('officePhones')"
                                  ></i>
                                  <i
                                    class="bi bi-dash-circle ms-1 remove-icon"
                                    *ngIf="officePhonesControls.length > 1"
                                    (click)="removeInput('officePhones',i)"
                                  ></i>
                                </div>
                                <div
                                  *ngIf="officeGroup && officeGroup.invalid && officeGroup.hasError('invalidPhoneNumber') || officeGroup.invalid"
                                  class="error-msg">
                                  <label for="" class="error">
                                    <img alt="" src="assets/images/icon/error.png" class="error-icon">
                                    Invalid phone number.
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="email-container width-240">
                            <div>
                              <label for="email" class="form-title mb-0">Email</label>
                              <div *ngFor="let emailControl of emailControls; let i = index" class="d-flex flex-column">
                                <div class="d-flex align-items-center">
                                  <input
                                    [id]="'email-' + i"
                                    type="text"
                                    class="form-control"
                                    [formControl]="emailControl"
                                  />
                                  <i
                                    class="bi bi-plus-circle ms-2 add-icon"
                                    *ngIf="i === emailControls.length - 1"
                                    (click)="addNewInput('email')"
                                  ></i>
                                  <i
                                    class="bi bi-dash-circle ms-2 remove-icon"
                                    *ngIf="emailControls.length > 1"
                                    (click)="removeInput('email', i)"
                                  ></i>
                                </div>
                                <app-form-error-component [control]="emailControl"></app-form-error-component>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
        
                    <div class="overflow-auto"
                         [style.width.%]="isCompareDialog ? 98 : 99"
                         [class.height-145]="addressArray.length === 1"
                         [class.height-180]="addressArray.length > 1"
                         formArrayName="addresses">
                      <div *ngFor="let address of addressArray.controls; let i = index; let last = last" [formGroupName]="i">
                        <div class="card dabetors-creditor-card">
                          <div class="card-header d-flex align-items-center">Address Details ({{ i + 1 }})
                            <i *ngIf="last" class="bi bi-plus-circle ms-2 add-icon" (click)="addAddressGroup()"></i>
                            <i *ngIf="addressArray.length > 1" class="bi bi-x-circle ms-2 remove-icon"
                               (click)="removeAddressGroup(i)"></i>
                          </div>
                        </div>
        
                        <div class="row margin-unset">
        
                          <div class="width-163">
                            <div>
                              <label for="address1" class="form-title">
                                <span class="required">*</span>Address 1</label>
                              <input
                                id="address1"
                                type="text"
                                class="form-control ft-width"
                                placeholder=""
                                formControlName="address1"
                              />
                            </div>
                          </div>
        
                          <div class="width-163">
                            <div>
                              <label for="address2" class="form-title">Address 2</label>
                              <input
                                id="address2"
                                type="text"
                                class="form-control ft-width"
                                placeholder=""
                                formControlName="address2"
                              />
                            </div>
                          </div>
        
                          <div class="width-135">
                            <div>
                              <label for="city" class="form-title"><span class="required">*</span>City</label>
                              <input type="text" class="form-control" formControlName="city" id="city" />
                            </div>
                          </div>
        
                          <div class="width-135">
                            <div>
                              <label for="state" class="form-title">State/County</label>
                              <input type="text" class="form-control" formControlName="state" id="state" />
                            </div>
                          </div>
        
                          <div class="width-110">
                            <div>
                              <label for="area" class="form-title">Area</label>
                              <input
                                id="area"
                                type="text"
                                class="form-control ft-width"
                                placeholder=""
                                formControlName="area"
                              />
                            </div>
                          </div>
        
                          <div class="width-80">
                            <div>
                              <label for="postCode" class="form-title">Post Code</label>
                              <input
                                id="postCode"
                                type="text"
                                class="form-control ft-width"
                                placeholder=""
                                formControlName="postCode"
                              />
                            </div>
                          </div>
        
                          <div class="width-135">
                            <div>
                              <label for="country" class="form-title">
                                <span class="required">*</span>Country</label>
                              <ng-select class="custom custom-dd"
                                         id="country"
                                         [style.flex]="1"
                                         [items]="countriesList"      
                                         bindLabel="name"
                                         bindValue="id"
                                         placeholder="All"
                                         formControlName="country">
                              </ng-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
        
                    <div class="overflow-auto"
                         *ngIf="showBankDetailsBlock"
                         [style.width.%]="isCompareDialog ? 98 : 99"
                         [class.height-145]="bankDetailsArray.length === 1"
                         [class.height-180]="bankDetailsArray.length > 1"
                         formArrayName="bankDetails">
                      <div *ngFor="let bank of bankDetailsArray.controls; let i = index; let last = last" [formGroupName]="i">
                        <div class="card dabetors-creditor-card">
                          <div class="card-header d-flex align-items-center">Bank Details ({{ i + 1 }})
                            <i *ngIf="last" class="bi bi-plus-circle ms-2 add-icon" (click)="addBankGroup()"></i>
                            <i *ngIf="bankDetailsArray.length > 1" class="bi bi-x-circle ms-2 remove-icon"
                               (click)="removeBankGroup(i)"></i>
                          </div>
                        </div>
                        <div class="row margin-unset" style="margin-bottom: 3px !important;">
                          <div class="width-90">
                            <div>
                              <label for="ccy" class="form-title">CCY</label>
                              <ng-select class="custom"
                                         id="ccy"
                                         [style.flex]="1"
                                         [items]="ccyList"
                                         
                                         bindLabel="name"
                                         bindValue="id"
                                         placeholder="All"
                                         formControlName="ccy">
                              </ng-select>
                            </div>
                            <app-form-error-component [control]="entityForm.controls['ccy']" />
                          </div>
        
                          <div class="width-173">
                            <div>
                              <label for="bank" class="form-title">Bank</label>
                              <ng-select class="custom custom-bank-dd"
                                         id="bank"
                                         [style.flex]="1"
                                         [items]="banksList"
                                         
                                         [addTag]="addNewTag"
                                         bindLabel="name"
                                         bindValue="entityId"
                                         placeholder="All"
                                         [clearable]="true"
                                         formControlName="bankId"
                                         (change)="handleBankChange($event, i)"
                              >
                              </ng-select>
                            </div>
                            <app-form-error-component [control]="entityForm.controls['bank']" />
                          </div>
        
                          <div class="width-120">
                            <div>
                              <label for="accountNumber" class="form-title"><span *ngIf="isBankRequired && isBankRequired !== 'none'" class="required">*</span> Bank Account</label>
                              <input
                                id="accountNumber"
                                type="text"
                                class="form-control ft-width"
                                placeholder=""
                                appOnlyNumber
                                formControlName="accountNumber"
                              />
                            </div>
                            <app-form-error-component [control]="entityForm.controls['accountNumber']" />
                          </div>
        
                          <div class="width-80">
                            <div>
                              <label for="sortCode" class="form-title"><span *ngIf="isBankRequired && isBankRequired !== 'none'" class="required">*</span> Sort Code</label>
                              <input
                                id="sortCode"
                                type="text"
                                class="form-control ft-width"
                                placeholder=""
                                maxlength="14"
                                formControlName="sortCode"
                                (input)="onSortCodeInput($event)"
                              />
                            </div>
                            <app-form-error-component [control]="entityForm.controls['sortCode']" />
                          </div>
        
                          <div class="width-85">
                            <div>
                              <label for="swiftBic" class="form-title"><span *ngIf="isBankRequired && isBankRequired !== 'none'" class="required">*</span> SWIFT BIC</label>
                              <input
                                id="swiftBic"
                                type="text"
                                class="form-control ft-width"
                                placeholder=""
                                maxlength="8"
                                style="text-transform: uppercase;"
                                formControlName="swiftBic"
                              />
                            </div>
                            <app-form-error-component [control]="entityForm.controls['swiftBic']" />
                          </div>
        
                          <div class="width-175">
                            <div>
                              <label for="iban" class="form-title">IBAN</label>
                              <input
                                id="iban"
                                type="text"
                                class="form-control ft-width"
                                placeholder=""
                                maxlength="34"
                                formControlName="iban"
                                style="text-transform: uppercase;"
                              />
                            </div>
                            <app-form-error-component [control]="entityForm.controls['iban']" />
                          </div>
                        </div>
                      </div>
                    </div>
        
                    <ng-container>
                      <div class="card dabetors-creditor-card">
                        <div class="card-header">Documents</div>
                      </div>
        
                      <div class="width-415">
        
                          <div id="doc" class="d-flex justify-content-between">
                            <div class="d-flex align-items-center">
                              <label for="etr" class="form-title me-1 mt-1">ETR</label>
                              <input formControlName="etrFile" id="etr" type="checkbox">
                            </div>
                            <div class="d-flex align-items-center">
                              <label for="contract" class="form-title me-1 mt-1">Contract</label>
                              <input formControlName="organisationFile" id="contract" type="checkbox">
                            </div>
                            <div class="d-flex align-items-center">
                              <label for="po" class="form-title me-1 mt-1">PO</label>
                              <input formControlName="POFile" id="po" type="checkbox">
                            </div>
                            <div class="d-flex align-items-center">
                              <label for="pod" class="form-title me-1 mt-1">PoD</label>
                              <input formControlName="PoDFile" id="pod" type="checkbox">
                            </div>
                            <div class="d-flex align-items-center">
                              <label for="signed" class="form-title me-1 mt-1">Signed</label>
                              <input formControlName="signedFile" id="signed" type="checkbox">
                            </div>
                            <div class="d-flex align-items-center">
                              <label for="fx" class="form-title me-1 mt-1">Fx</label>
                              <input formControlName="fxFile" id="fx" type="checkbox">
                            </div>
                            <div class="d-flex align-items-center">
                              <label for="proof" class="form-title me-1 mt-1">Proof</label>
                              <input formControlName="proofFile" id="proof" type="checkbox">
                            </div>
                          </div>
                        </div>
                    </ng-container>
                  </div>
        
        
                  <div *ngIf="!isCompareDialog" class="col-12 bottom-fixed mt-3">
                    <div class="d-flex justify-content-center ">
                      <button [disabled]="entityForm?.invalid" type="submit"
                              class="btn btn-light me-3 btn-custom-footer save_btn">
                        Save
                      </button>
                      <button type="button" class="btn btn-light btn-custom-footer cancel_btn" data-dismiss="modal"
                              (click)="closeModal()">
                        Cancel
                      </button>
                    </div>
                  </div>
                  <div *ngIf="isCompareDialog" class="col-12 bottom-fixed mt-3">
                    <div class="d-flex justify-content-center ">
                      <button [disabled]="entityForm?.invalid" type="submit"
                              class="btn btn-light me-3 btn-custom-footer save_btn">
                        Save
                      </button>
                      <button type="button" class="btn btn-light btn-custom-footer cancel_btn" data-dismiss="modal"
                              (click)="startDeleteEntity()">
                        Delete
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        
      </div>





























